<template>
	<div>
		<!-- ------------------------------忘記密碼開始------------------------------ -->
        <div class="modal fade cm-modal" id="forgotPasswordModal" tabindex="-1" role="dialog"
            aria-labelledby="forgotPasswordModalTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header text-center cm-modal-forgot-header p-0">
                        <h4 class='col-12 modal-title text-center p-0 m-0 row'>
                            <div class="col-6 cm-modal-title">
                                {{$t('modal.ForgotPassword.Title')}}
                            </div>
                            <div class="col-6 cm-modal-href">
                                <a href="#" class="text-center d-block w-100" data-toggle="modal"
                                    data-target="#forgotAccountModal">{{$t('modal.ForgotAccount.Title')}}</a>
                                <button type="button" class="close cm-forgot-close" data-dismiss="modal"
                                    aria-label="Close">
                                    <img src="@/assets/images/login-close.png">
                                </button>
                            </div>
                        </h4>
                    </div>
                    <div class="modal-body p-md-5 p-3 cm-modal-forgot-body">
                        <div>
                            <span>
                                {{$t('modal.ForgotPassword.Content1')}}
                            </span>
                        </div>
                        <div class="pt-3">
                            <input v-model="account" v-on:blur="accountMonitor" type="text" class="form-control" :placeholder="$t('modal.ForgotPassword.Placeholder.Account')">
                            <label class="text-danger" v-if="accountPromptString !== ''"  v-html="accountPromptString"></label>
                        </div>
                        <div class="pt-3">
                            <input v-model="email" readonly class="form-control" :placeholder="$t('modal.ForgotPassword.Placeholder.RegisteredEmail')">
                        </div>
                        <div class="pt-3">
                            <span>
                                {{$t('modal.ForgotPassword.Content2')}}
                            </span>
                        </div>
                        <div class="col py-2">
                            <div v-if="domControl.isWaitingSendEmailToChangePasswordAjax==true" class="spinner-border text-warning text-center d-block mx-auto" role="status"></div>
                            <button v-else @click="submitBtn" type="button" class="btn btn-lg text-white cm-forgot-send-button">{{$t('modal.ForgotPassword.Confirm')}}</button>
                        </div>
                        <img src="@/assets/images/cmi_logo_black.png" class="cm-forgot-logo-img">
                    </div>
                </div>
            </div>
        </div>
        <!-- ------------------------------忘記密碼結束------------------------------ -->
	</div>
</template>

<script>
import $ from 'jquery'
import axios from 'axios'
import eventBus from '@/assets/js/event/EventBus.js'
import RecaptchaUtil from "@/assets/js/util/RecaptchaUtil.js"
export default {
    data() {
        return {
            account: "",
            accountPromptString: "",
            email: "",
            domControl: {
                isWaitingSendEmailToChangePasswordAjax: false
            }
        }
    },
    mounted() {
        const self = this;
        $('#forgotPasswordModal').on('hidden.bs.modal', function () {
            self.resetData();
        })
    },
    methods: {
        resetData() {
            this.account = "";
            this.accountPromptString = "";
            this.email = "";
        },
        async accountMonitor() {
            if(this.account == "") {
                this.accountPromptString = "*" + this.$i18n.t('modal.ForgotPassword.Prompt.Input.Account');
                this.email = "";
                return;
            }
            else if(this.account != "") {
                // 清除資料
                this.accountPromptString = "",
                this.email = "";

                // Ajax
                let bodyFormData = new FormData();
                bodyFormData.append("memberMultiId.subAccount", this.account);
                bodyFormData.append("request_locale", this.$i18n.locale.replace("-", "_"));
                bodyFormData.append("_", new Date().getTime());
                const self = this;
                const response = await axios({
                    method: "post",
                    url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/retrieveEamilAction.shtml",
                    timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                    data: bodyFormData,
                    config: { headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }}
                })
                .catch(function(response) {
                    alert(self.$i18n.t('common.Backend.Response.ConnectionFailed'))
                })

                // 判斷Ajax回傳結果
                if(response!=undefined && response.data!=undefined) {
                    if(response.data.status=="success") {
                        this.email = response.data.email;
                    }
                    else if(response.data.status=="fail") {
                        this.accountPromptString = "* " + response.data.message;
                    }
                }
            }
        },
        async submitBtn() {
            // 檢查
            await this.accountMonitor();
            if(this.accountPromptString != "") {
                return;
            }

            const self = this
            RecaptchaUtil.startGoogleRecaptchaVerify(
                process.env.VUE_APP_AUTH_RECAPTCHA_FORGOT_PASSWORD,
                async function(gRecaptchaResponse) {
                    let bodyFormData = new FormData();
                    bodyFormData.append("memberMultiId.subAccount", self.account);
                    bodyFormData.append("textfield", self.email);
                    bodyFormData.append("request_locale", self.$i18n.locale.replace("-", "_"));
                    bodyFormData.append("mydomain", "all9fun.com");
                    bodyFormData.append("g-recaptcha-response", gRecaptchaResponse);
                    
                    // 開啟Ajax等待動畫
                    self.domControl.isWaitingSendEmailToChangePasswordAjax = true;

                    // Ajax
                    const response = await axios({
                        method: "post",
                        url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/sendEmailToChangePasswordJsonAction.shtml",
                        timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                        data: bodyFormData,
                        config: { headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }}
                    })
                    .catch(function(response) {
                        alert(self.$i18n.t('common.Backend.Response.ConnectionFailed'))
                    })
                    
                    // 關閉Ajax等待動畫
                    self.domControl.isWaitingSendEmailToChangePasswordAjax = false;
                    
                    // 判斷Ajax結果
                    if(response!=undefined && response.data!=undefined) {
                        if(response.data.result=="success") {
                            alert(self.$i18n.t('modal.ForgotPassword.Backend.Response'));
                        }
                        else {
                            alert("error");
                        }
                    }
                }
            )
        }
    }
}
</script>